(function (angular) {
    angular
        .module('harriApp')
        .controller('removeJobModal', [
            '$scope', '$state', 'modalData','onSave',
            function ($scope, $state, modalData, onSave) {

                $scope.modalData = modalData;
                $scope.jobsName = modalData.jobsName;

                $scope.onDontShowChange = function () {
                    if ($scope.dontShow) {
                        HStorageManager.put({
                            storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                            key: 'dontShowRemoveJobWarning',
                            value: 'confirmed'
                        })
                    } else {
                        HStorageManager.remove({
                            storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                            key: 'dontShowRemoveJobWarning'
                        });
                    }
                };

                $scope.save = function () {
                    onSave();
                    $scope.$hide();
                };

                //Hide modal
                $scope.close = function () {
                    $scope.$hide();
                };

                $scope.init = function () {
                    if (HStorageManager.get({
                            storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                            key: 'dontShowRemoveJobWarning'
                        }) &&
                        HStorageManager.get({
                            storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                            key: 'dontShowRemoveJobWarning'
                        }) === 'confirmed') {
                        $scope.$hide();
                        onSave();
                    }
                };

                $scope.init();
            }]);
})(angular);
